export default {
  bannerdialog: 'mx-auto w-full',
  bannerHelper: {
    richtextMargin: 'mt-15 md:mt-20',
    buttonMargin: 'mt-20 md:mt-30',
  },
  'banner-text-left': {
    cardWrapper: 'relative primary-banner',
    container:
      'lg:w-container text-left sm:max-w-full sm:my-30 md:my-0 md:absolute md:inset-x-0 z-10',
    contentWidth: 'md:w-6/12',
    badgeImage: 'h-s80-l100 mb-20',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'home-banner-text-center': {
    cardWrapper: 'relative primary-banner',
    container:
      'sm:text-center text-left sm:max-w-full sm:w-full  md:my-0 sm:absolute md:absolute sm:mt-50p md:mt-30p md:inset-x-0 z-10',
    contentWidth: 'md:w-full text-center',
    badgeImage: 'h-s80-l100 mb-20',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'home-banner-text-reverse': {
    cardWrapper:
      'flex items-start sm:flex-col-reverse md:flex-row-reverse flex-equal picture-inline-flex home-section',
    container:
      'md:flex md:items-center md:text-left sm:w-11/12 sm:mx-auto sm:my-0 sm:-mt-40p sm:p-20 sm:bg-white z-1 md:my-0 md:w-51p md:pl-80 home-text-right',
    contentWidth: 'sm:text-center md:text-left banner-text md:w-9/12',
    badgeImage: '',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'home-banner-text-right': {
    cardWrapper:
      'md:flex items-start  md:flex-row-reverse flex-equal picture-inline-flex home-section',
    container:
      'sm:flex sm:items-center md:flex md:items-center md:text-left sm:w-full md:my-0 md:w-51p md:pl-80 home-section-right',
    contentWidth: 'sm:w-full sm:text-center md:text-left banner-text md:w-9/12',
    badgeImage: '',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'home-banner-text-right-sticky': {
    cardWrapper:
      'md:flex items-start md:flex-row-reverse flex-equal picture-inline-flex home-section sticky-card',
    container:
      'md:flex md:items-center md:text-left sm:w-full  md:my-0 md:w-51p md:pl-80 home-text-right',
    contentWidth: 'md:w-9/12 sm:text-center md:text-left banner-text',
    badgeImage: '',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'article-banner-text-left': {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse article-page-test-banner mb-40 commonBanner commonBannerThree',
    container:
      'flex items-center flex-equal md:relative pin-r10 w-12/12 md:w-12/12 lg:w-12/12',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white md:pl-50 md:py-46 sm:p-0 sm:text-center md:text-left sm:-mt-140 md:mt-0 sm:z-3',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  'essenciais-article-banner-text-left': {
    cardWrapper:
      'relative  flex md:flex-nowrap flex-wrap flex-row md:flex-row-reverse sm:flex-col-reverse article-page-test-banner essentialArticle md:mb-40 commonBannerFour',
    container:
      'flex items-center md:w-6/12 w-full',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white md:pl-50 md:py-46 sm:p-0 sm:text-center md:text-left md:mt-0 sm:z-3',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  'article-detail-wrapper': {
    cardWrapper: 'relative primary-banner',
    container: 'w-full lg:w-container lg:w-8/12',
  },
  'article-detail-banner-wrapper': {
    cardWrapper: 'article-deatil-banner-container  relative primary-banner',
    container:
      'w-full lg:w-container lg:w-8/12 absolute text-white left-0 right-0 mb-30',
    contentWidth: '',
    badgeImage: 'h-s80-l100 mb-20',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'banner-img-60-left': {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80 commonBannerSix',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 z-10 bg-white w-12/12 md:w-6/12 md:-ml-10p',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 sm:px-20 md:pt-40 md:pb-50 md:px-30 sm:text-center md:text-left sm:-mt-90 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  SafetyQualityThirdBanner: {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:my-80',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 z-10 bg-white w-12/12 md:w-6/12 md:-ml-10p',
    contentWidth:
      'w-full sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 px-20 md:pt-15 md:pb-20 md:px-50 sm:text-center md:text-left sm:-mt-20  md:-mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',

  },
  safetyQualitySixthBanner: {
    cardWrapper:
      'flex flex-wrap flex-col-reverse md:flex-row-reverse justify-end items-center widthdesk',
    container:
      'text-left bg-white sm:max-w-full sm:my-30 md:my-0 z-10 w-12/12 md:w-6/12 md:-ml-5p safetyQualitySixthBannerrightcontent',
    contentWidth:
      'md:w-full sm:w-11/12 bg-white  sm:mx-auto banner-text sm:pb-14 sm:px-20 md:pb-50 md:pt-50 md:px-30 sm:text-center md:text-left sm:-mt-90 md:mt-0 sm:z-10 ',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  SafetyFiveDesktopBanner: {
    cardWrapper:
      'flex flex-wrap flex-col-reverse justify-end items-center widthdesk',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 z-10 w-12/12 md:w-10/12 md:-ml-10p',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text sm:pb-14 sm:px-20 md:pb-50 md:px-30 sm:text-center md:text-left sm:-mt-90 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  SafetyFiveMobileBanner: {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80 SafetyFiveMobileBanner',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 z-10 bg-white w-12/12 md:w-6/12 md:-ml-10p',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text pt-0 sm:pb-14 sm:px-20 md:pt-40 md:pb-50 md:px-30 sm:text-center md:text-left sm:-mt-100 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  SafetySeventhBanner: {
    cardWrapper:
      'relative  flex flex-wrap flex-col-reverse md:items-center md:justify-end',
    container:
      'text-left right-0 absolute flex justify-end items-center h-full z-10 w-12/12 md:w-6/12 SafetySeventhBannercontainer',
    contentWidth:
      'md:w-full w-11/12 mx-auto banner-text bg-white px-20 py-20 sm:text-center md:text-left z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  'Manifestobanner-img-60-left': {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80',
    container:
      'text-left sm:max-w-full sm:my-30 sm:mt-0 md:my-0 z-10 bg-white mx-auto md:mx-0 w-90p  leading-2.5v md:text-left p-4p h-auto md:w-6/12 md:-ml-10p md:p-4p m-0 Manifestobanner-img-60-leftcontainer manifestoHorizontalCardcontainer',
    contentWidth:
      'md:w-full sm:w-12/12 sm:mx-0 banner-text bg-white  sm:text-left  sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  'Nonobanner1-img-60-left': {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80 commonBannerFive ',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 z-10 w-12/12 md:w-6/12',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text sm:pt-30 sm:pb-14 sm:px-20 md:pt-40 md:pb-50 md:px-30 sm:text-center md:text-left md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  'Nonobanner1-img-60-left-2': {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80',
    container:
      'text-left sm:max-w-full my-0 md:my-30 md:my-0 z-10 bg-white w-12/12 md:w-6/12 md:-ml-10p',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white pt-10 sm:pb-14 sm:px-20 md:pt-40 md:pb-50 md:px-30 sm:text-center md:text-left md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
    releatedCard: 'flex justify-center'
  },
  'banner-img-60-second-left': {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 z-10 bg-white w-12/12 md:w-6/12 md:-ml-10p',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 sm:px-20 md:pt-70 md:pb-86 md:px-30 sm:text-center md:text-left sm:-mt-90 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  'banner-img-60-right': {
    cardWrapper:
      'relative  flex md:flex-row sm:flex-col-reverse md:items-center md:justify-end picture-60',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 md:-mr-10p z-10 bg-white w-12/12 md:w-6/12',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 px-20 md:pt-40 md:pb-50 md:px-30 sm:text-center md:text-left sm:-mt-140 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  savewaterBanner: {
    cardWrapper:
      'relative  md:items-center md:justify-end picture-60 commonBannerTen',
    container:
      'absolute w-auto text-center  md:my-0 md:-mr-10p z-10 bg-white  savewaterBannercontent',
    contentWidth:
      'w-12/12 md:w-full px-2p py-2p  m-0 banner-text bg-white  md:py-2p md:px-30 text-center  md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },

  'anita-Banner-right-content': {
    cardWrapper:
      'relative  md:items-center md:justify-end picture-60',
    container:
      'absolute w-auto text-left flex items-center justify-end md:my-0  z-10 anitabannercontent',
    contentWidth:
      'w-12/12 md:w-6/12 px-2p py-2p  m-0 banner-text md:py-2p md:px-30 text-left md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },

  'anita-Banner-left-content': {
    cardWrapper:
      'relative  md:items-center md:justify-end picture-60',
    container:
      'absolute w-auto text-left flex items-center justify-start md:my-0  z-10 anitaleftbannercontent',
    contentWidth:
      'w-12/12 md:w-6/12 px-2p py-2p  m-0 banner-text md:py-2p md:px-30 text-left md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  'anita-Banner-left-top-content': {
    cardWrapper:
      'relative  md:items-center md:justify-end picture-60',
    container:
      'absolute w-auto text-left flex items-center justify-start md:my-0  z-10 anitalefttopbannercontent',
    contentWidth:
      'w-12/12 md:w-6/12 px-2p py-2p  m-0 banner-text md:py-2p md:px-30 text-left md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  'anita-Banner-left-center-content': {
    cardWrapper:
      'relative  md:items-center md:justify-end picture-60',
    container:
      'absolute w-auto text-center md:text-left lg:text-left flex items-center justify-start md:my-0  z-10 anitaleftcenterbannercontent',
    contentWidth:
      'w-12/12 md:w-6/12 px-2p py-2p  m-0 banner-text md:py-2p md:px-30 text-center md:text-left lg:text-left md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },

  'anita-Banner-center-content': {
    cardWrapper:
      'relative  md:items-center md:justify-end picture-60',
    container:
      'absolute w-auto text-center flex items-center justify-center md:my-0  z-10 anitacenterbannercontent',
    contentWidth:
      'w-12/12 md:w-6/12 px-2p py-2p  m-0 banner-text md:py-2p md:px-30 text-center md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },

  'anita-Banner-main-content': {
    cardWrapper:
      'relative  md:items-center md:justify-end picture-60',
    container:
      'absolute w-auto text-center flex items-center justify-end md:my-0  z-10 anitacentermainbannercontent',
    contentWidth:
      'w-12/12 md:w-6/12 px-2p py-2p flex flex-col items-center m-0 banner-text md:py-2p md:px-30 text-center md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },

  savewaterSobreBanner: {
    cardWrapper:
      'relative  flex md:flex-row md:flex-row-reverse md:mt-8p sm:flex-col-reverse md:items-center md:justify-end picture-60   savewaterSobreBannercontaier',
    container:
      'text-left md:absolute sm:max-w-full sm:my-30 md:my-0 md:-mr-10p z-10 bg-white w-12/12 md:w-6/12 savewaterSobreBannercontaierright',
    contentWidth:
      'md:w-full w-85p sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 px-8p md:px-10p  md:p-0 sm:text-center md:text-left sm:-mt-140  sm:z-10 savewaterSobreBannercontent',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  savewatervoicesaboBanner: {
    cardWrapper:
      'relative  flex flex-row-reverse md:items-center md:justify-end picture-60  savewatervoicesaboBannecard',
    container:
      'text-left w-70p sm:my-30 md:my-0 md:-mr-10p z-10 bg-white w-12/12 md:w-12/12',
    contentWidth:
      ' sm:w-11/12 sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 px-20 md:p-0 md:ml-4p md:w-72p sm:text-center md:w-12/12 md:text-left sm:-mt-140 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  'RecycleBanner': {
    cardWrapper:
      'relative  md:flex sm:flex-col-reverse md:items-center md:justify-end picture-60 md:flex-row-reverse RecycleBannerrcontainer commonBannerNine',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 md:-mr-10p z-10 bg-white w-12/12 md:w-48p RecycleBannerright',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 px-20 md:p-0 md:m-0  sm:text-center md:text-left sm:-mt-140  sm:z-10',
    badgeImage: ' image1',
    bannerImageSet: '',
  },
  'banner-img-60-left-look-banner': {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 z-10 bg-white w-12/12 md:w-6/12 md:-ml-10p',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 sm:px-20 md:pt-100 md:pb-100 md:px-30 sm:text-center md:text-left sm:-mt-90 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },

  'banner-img-60-second-left-look': {
    cardWrapper:
      'relative  flex md:flex-row-reverse sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 z-10 bg-white w-12/12 md:w-6/12 md:-ml-10p  md:min-h-380 lg:min-h-425',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 sm:px-20 md:pt-30 md:px-30 sm:text-center md:text-left sm:-mt-90 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },

  'banner-img-60-right-look': {
    cardWrapper:
      'relative  flex md:flex-row sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80',
    container:
      'text-left sm:max-w-full sm:my-30 md:my-0 md:-mr-10p z-10 bg-white w-12/12 md:w-6/12 md:min-h-380 lg:min-h-425',
    contentWidth:
      'md:w-full sm:w-11/12 sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 px-20 md:pt-30 md:pb-50 md:px-30 sm:text-center md:text-left sm:-mt-140 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },

  'power-of-grey-banner': {
    cardWrapper: 'cardWrapper flex items-center flex-col-reverse lg:flex-row',
    container: 'container sm:max-w-full z-9',
    contentWidth: '',
    badgeImage: 'badgeImage',
    bannerImageSet: 'bannerImageSet',
  },
  'grey-and-glowing-banner': {
    cardWrapper: 'cardWrapper',
    container: 'container',
    contentWidth: '',
    badgeImage: 'badgeImage',
    bannerImageSet: 'bannerImageSet',
  },
  'hair-gender-banner': {
    cardWrapper: 'relative primary-banner mb-30 lg:mb-80',
    container:
      'lg:w-container text-center sm:max-w-full px-30 lg:px-0 md:my-0 absolute md:inset-x-0 z-10 mx-auto',
    contentWidth: 'md:w-full flex flex-col-reverse',
    badgeImage:
      'h-s80-l100 w-293 bg-black mx-auto max-h-62 lg:max-h-88 px-40 lg:px-100 py-15 lg:py-23',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'hair-biology-text-left': {
    cardWrapper: 'relative primary-banner',
    container: 'text-center md:text-left sm:max-w-full',
    contentWidth: 'md:w-full hair-biology-text-left px-16 lg:px-0',
    badgeImage: 'h-s80-l100 mb-20',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'hair-biology-text-right': {
    cardWrapper: 'relative primary-banner overflow-hidden',
    container: 'text-center md:text-left sm:max-w-full',
    contentWidth: 'md:w-full hair-biology-text-right px-16 lg:px-0',
    badgeImage: 'h-s80-l100 mb-20',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'prov-banner': {
    cardWrapper: 'relative primary-banner overflow-hidden',
    container: 'text-center md:text-left sm:max-w-full',
    contentWidth: 'md:w-full hair-biology-text-right px-16 lg:px-0',
    badgeImage: 'h-s80-l100 mb-20',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  safetyHeadingBanner: {
    cardWrapper: 'safetyHeadingBanner relative primary-banner overflow-hidden flex flex-wrap flex-col-reverse',
    container: 'text-center',
    contentWidth: '',
    badgeImage: 'h-s80-l100 mb-20',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  "novadaprovbanner": {
    cardWrapper:
      'relative  flex md:flex-row sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80 mt-30 md:mt-40 lg:mt-60',
    container:
      'text-left sm:max-w-full  md:my-0 z-10 bg-white w-12/12 md:w-6/12  -mt-10 md:mt-0',
    contentWidth:
      'w-full sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 px-20 md:pt-15 md:pb-20 md:px-0 sm:text-center md:text-left -mt-30 mdp:-mt-65 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',

  },
  'article-hero-stripe':
  {
    cardWrapper:
      'article-hero-stripe md:flex commonBannerNine',
    container:
      'stripecontainer md:w-25p',
    contentWidth:
      'stripecontentwidth w-12/12 absolute',
    badgeImage: 'stripebadgeimages',
    bannerImageSet: 'stripeimageset',
  },
  safetyHeadingBannerMain: {
    cardWrapper: 'safetyHeadingBanner relative primary-banner overflow-hidden',
    container: 'text-center md:text-left sm:max-w-full',
    contentWidth: '',
    badgeImage: 'h-s80-l100 mb-20',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'prov-bannernew': {
    cardWrapper: 'relative primary-banner',
    container:
      'lg:w-container text-left sm:max-w-full sm:my-30 md:my-0 md:absolute md:inset-x-0 z-10 h-full',
    contentWidth: 'md:w-6/12 h-full flex justify-center md:mt-40 md:ml-40 text-center provsection',
    badgeImage: 'h-s80-l100 mb-20',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  "novadashampoobanner": {
    cardWrapper:
      'relative bg-lightGrey img-top flex md:flex-row sm:flex-col-reverse md:items-center md:justify-end picture-60  sm:mb-26 md:mb-70 mt-60 md:mt-40 lg:mt-60',
    container:
      'text-left sm:max-w-full md:my-0 z-10 bg-lightGrey w-12/12 md:w-6/12  -mt-10 md:mt-0',
    contentWidth:
      'w-full sm:mx-auto banner-text bg-lightGrey sm:pt-30 sm:pb-14 px-20 md:pt-15 md:pb-20 md:px-0 md:px-50 sm:text-center md:text-left -mt-30 mdp:-mt-65 md:mt-0 sm:z-10',
    badgeImage: '',
    bannerImageSet: '',
  },
  "novadapresentbanner": {
    cardWrapper:
      'relative  flex md:flex-row sm:flex-col-reverse md:items-center md:justify-end picture-60 sm:mb-26 md:mb-80',
    container:
      'text-left sm:max-w-full  md:my-0 z-10 bg-white w-12/12 md:-ml-10p -mt-10 md:mt-0',
    contentWidth:
      'w-full sm:mx-auto banner-text bg-white sm:pt-30 sm:pb-14 px-20 md:pt-15 md:pb-20 md:px-50 sm:text-center md:text-left -mt-30 mdp:-mt-65 md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',

  },
  "novadamascarbanner": {
    cardWrapper:
      'relative bg-lightGrey img-top flex md:flex-row sm:flex-col-reverse md:items-center md:justify-end picture-60  sm:mb-26 md:mb-70 mt-30 md:mt-40 lg:mt-60',
    container:
      'text-left sm:max-w-full md:my-0 z-10 bg-lightGrey w-12/12 md:w-6/12  -mt-10 md:mt-0',
    contentWidth:
      'w-full sm:mx-auto banner-text bg-lightGrey sm:pt-30 sm:pb-14 px-20 md:pt-15 md:pb-20 md:px-0 md:px-50 sm:text-center md:text-left -mt-30 mdp:-mt-65 md:mt-0 sm:z-10',
    badgeImage: '',
    bannerImageSet: '',
  },
  'vita-main-banner': {
    cardWrapper:
      'relative md:items-center md:justify-end picture-60',
    container:
      'absolute sm:w-full md:w-auto text-center flex items-center justify-end md:my-0 z-10 vitamainbannercontent',
    contentWidth:
      'w-12/12 px-2p py-2p flex flex-col items-center m-0 banner-text md:py-2p md:px-30 text-center md:mt-0 sm:z-10',
    badgeImage: ' ',
    bannerImageSet: '',
  },
  contentPosition: {
    'Top-Left': {
      container: 'top-0',
      textBlock: '',
    },
    'Top-Center': {
      container: 'top-0',
      textBlock: '',
    },
    'Top-Right': {
      container: 'top-0',
      textBlock: '',
    },
    'Middle-Left': {
      container: '',
      textBlock: '',
    },
    'Middle-Center': {
      container: '',
      textBlock: '',
    },
    'Middle-Right': {
      container: '',
      textBlock: '',
    },
    'Bottom-Left': {
      container: 'bottom-0',
      textBlock: '',
    },
    'Bottom-Center': {
      container: 'bottom-0',
      textBlock: '',
    },
    'Bottom-Right': {
      container: 'bottom-0',
      textBlock: '',
    },
  },
  'marvel-banner-text-left': {
    cardWrapper:
      'md:flex items-start flex-equal picture-inline-flex marvel-image-section marvel-banner-text-left',
    container:
      'sm:flex sm:items-center md:flex md:items-center lg:items-center md:text-left sm:w-full md:my-0 md:w-53p md:pl-80 marvel-text-container',
    contentWidth: 'sm:w-full sm:text-center md:text-left md:mr-10 marvel-banner-text',
    badgeImage: '',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
  'marvel-banner-text-right': {
    cardWrapper:
      'md:flex items-start lg:flex lg:flex-row-reverse md:flex-row-reverse flex-equal picture-inline-flex marvel-image-section marvel-banner-text-right',
    container:
      'sm:flex sm:items-center md:flex md:items-center lg:items-center md:text-left sm:w-full md:my-0 md:w-53p md:pl-80 marvel-text-container',
    contentWidth: 'sm:w-full sm:text-center md:text-left md:mr-10 marvel-banner-text',
    badgeImage: '',
    bannerImageSet:
      'md:w-auto md:pin-l50 lg:left-0 md:relative lg:static md:-translate-x50 lg:translate-xy0 z-0',
  },
};
